<template>
  <div class="ch-adult-btn two-btn">
    <ul>
      <li>
        <a href="#" @click.prevent="cancel" class="round-btn-black-b">취소</a>
      </li>
      <li>
        <a href="#" @click.prevent="confirm" class="round-btn-purple-f">확인</a>
      </li>
    </ul>
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'ChildrenProtectionBottomButtons',
  props: {
    scopedValue: {
      type: Object
    }
  },
  methods: {
    cancel () {
      const referer = get(this.$route, 'query.referer', '')
      const target = referer === '' ? '/' : referer
      this.$router.replace(target)
    },
    confirm () {
      if (typeof this.scopedValue.confirmFn === 'function') {
        console.log('children confirm action')
        console.log(this.scopedValue)
        this.scopedValue.confirmFn()
      }
    }
  }
}
</script>
